import { Link } from "react-router-dom";
import { WarningIcon as Warning, CheckCircleIcon as CheckCircle, XIcon as X } from "@phosphor-icons/react";
import { staleCheckLink, staleCheckMessage, staleCheckNeedsAttention } from "@/lib/staleCheck";

/** Compact strip under the import toolbar: result of the disposition stale auto-check the last import ran. */
export default function StaleCheckNotice({ workspaceId, check, trigger, onDismiss }) {
  if (!check?.stale_checked) return null;
  const attention = staleCheckNeedsAttention(check);
  const link = staleCheckLink(workspaceId, check);
  const tone = attention
    ? "border-[#ff832b]/50 bg-[#ff832b]/10 text-[#8a3800]"
    : "border-[#0e6027]/30 bg-[#0e6027]/[0.06] text-[#0e6027]";
  return (
    <div className={`flex flex-wrap items-center gap-2 border px-3 py-2 text-xs ${tone}`} role="status" aria-live="polite" data-testid="stale-check-notice" data-flagged={check.stale_flagged || 0} data-cleared={check.stale_cleared || 0}>
      {attention ? <Warning size={14} weight="fill" /> : <CheckCircle size={14} weight="fill" />}
      <span data-testid="stale-check-message">
        {staleCheckMessage(check)}
        {trigger ? <span className="opacity-80"> Triggered by {trigger} import.</span> : null}
      </span>
      {link && (
        <Link to={link} className="underline hover:no-underline font-medium" data-testid="stale-check-link">
          Open stale dispositions →
        </Link>
      )}
      <button type="button" onClick={onDismiss} className="ml-auto p-0.5 opacity-70 hover:opacity-100" aria-label="Dismiss" data-testid="stale-check-dismiss">
        <X size={12} />
      </button>
    </div>
  );
}
